export enum RoleConstants {
  SUPER_ADMIN = "Super Admin",
  BASIC = "Basic",
}
